



// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { doc, getDoc, collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
// import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
// import { db } from '../../firebase/firebaseConfig';
// import './ProfilePage.css';

// const ProfilePage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [recentOrders, setRecentOrders] = useState([]);
//   const [recentPointsActivity, setRecentPointsActivity] = useState([]);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
//   const auth = getAuth();

//   // Function to fetch user data from Firestore
//   const fetchUserData = useCallback(async (user) => {
//     try {
//       setLoading(true);

//       if (!user || !user.uid) {
//         throw new Error('User not authenticated');
//       }

//       console.log("Fetching user data for:", user.uid);

//       // Set initial user data from auth
//       const initialUserData = {
//         uid: user.uid,
//         email: user.email || '',
//         name: user.displayName || 'User'
//       };

//       // Fetch complete user data from Firestore - using proper query
//       try {
//         // First try to get user document directly
//         const userDocRef = doc(db, 'users', user.uid);
//         const userDocSnap = await getDoc(userDocRef);

//         if (userDocSnap.exists()) {
//           console.log("Found user document directly with ID:", user.uid);
//           const firestoreData = userDocSnap.data();

//           // Merge with existing data
//           const mergedData = {
//             ...initialUserData,
//             ...firestoreData,
//             lastUpdated: new Date().toISOString()
//           };

//           setUserData(mergedData);

//           // Save to localStorage as a cache
//           localStorage.setItem('userData', JSON.stringify(mergedData));
//         } else {
//           // Try to find user by email as fallback
//           console.log("User document not found by ID, trying email query");
//           const usersRef = collection(db, 'users');
//           const q = query(usersRef, where('email', '==', user.email));
//           const querySnapshot = await getDocs(q);

//           if (!querySnapshot.empty) {
//             const firestoreData = querySnapshot.docs[0].data();
//             const firestoreUserId = querySnapshot.docs[0].id;

//             console.log("Found user by email query with ID:", firestoreUserId);

//             // Merge with existing data
//             const mergedData = {
//               ...initialUserData,
//               ...firestoreData,
//               uid: firestoreUserId,
//               lastUpdated: new Date().toISOString()
//             };

//             setUserData(mergedData);

//             // Save to localStorage as a cache
//             localStorage.setItem('userData', JSON.stringify(mergedData));
//           } else {
//             console.log("No user document found in Firestore. Using basic auth data.");
//             setUserData(initialUserData);
//             localStorage.setItem('userData', JSON.stringify(initialUserData));
//           }
//         }
//       } catch (firestoreError) {
//         console.error("Error fetching user data from Firestore:", firestoreError);
//         // Continue with auth data
//         setUserData(initialUserData);
//       }

//     } catch (error) {
//       console.error("Error in profile page:", error);
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   // Fetch recent orders
//   const fetchRecentOrders = useCallback(async (userId) => {
//     try {
//       if (!userId) return;

//       const ordersRef = collection(db, 'orders');
//       const q = query(
//         ordersRef,
//         where('userId', '==', userId),
//         orderBy('createdAt', 'desc'),
//         limit(5)
//       );

//       const querySnapshot = await getDocs(q);
//       const ordersData = [];

//       querySnapshot.forEach((doc) => {
//         ordersData.push({
//           id: doc.id,
//           ...doc.data(),
//           createdAt: doc.data().createdAt ? doc.data().createdAt.toDate() : new Date()
//         });
//       });

//       setRecentOrders(ordersData);

//       // Extract points activity from orders
//       const pointsActivity = ordersData.map(order => ({
//         id: order.id,
//         date: order.createdAt,
//         description: `Order: ${order.productName}`,
//         points: order.pointsEarned || 0,
//         type: 'earned'
//       }));

//       setRecentPointsActivity(pointsActivity);

//     } catch (error) {
//       console.error("Error fetching recent orders:", error);
//     }
//   }, []);

//   // Main useEffect to check authentication and load user data
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         fetchUserData(user);
//         fetchRecentOrders(user.uid);
//       } else {
//         // User is not logged in
//         setLoading(false);
//         navigate('/login');
//       }
//     });

//     // Cleanup subscription
//     return () => unsubscribe();
//   }, [navigate, auth, fetchUserData, fetchRecentOrders, refreshTrigger]);

//   // Listen for profile refresh events
//   useEffect(() => {
//     // Force refresh when returning from order page
//     const checkForRefresh = () => {
//       const params = new URLSearchParams(location.search);
//       if (params.get('refresh') === 'true') {
//         console.log("Detected refresh parameter, triggering data reload");
//         setRefreshTrigger(prev => prev + 1);

//         // Clean up the URL
//         navigate('/profile', { replace: true });
//       }
//     };

//     checkForRefresh();

//     // Listen for custom refresh events
//     const handleRefreshEvent = () => {
//       console.log("Received profile refresh event");
//       setRefreshTrigger(prev => prev + 1);
//     };

//     window.addEventListener('refreshProfile', handleRefreshEvent);

//     return () => {
//       window.removeEventListener('refreshProfile', handleRefreshEvent);
//     };
//   }, [location, navigate]);

//   // Manually refresh profile data
//   const handleRefreshProfile = () => {
//     console.log("Manual refresh triggered");
//     setLoading(true);
//     setRefreshTrigger(prev => prev + 1);
//   };

//   const handleLogout = async () => {
//     try {
//       setLoading(true);

//       // Use Firebase signOut instead of manually clearing localStorage
//       await signOut(auth);

//       // Clear user data from localStorage
//       localStorage.removeItem('userData');
//       localStorage.removeItem('authToken');

//       // Use in-memory variable instead of sessionStorage
//       window.hasSeenWelcome = false;

//       // Dispatch logout event if needed
//       window.dispatchEvent(new Event('userLoggedOut'));

//       navigate('/login');
//     } catch (error) {
//       console.error("Error during logout:", error);
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="profile-container">
//         <div className="loading-spinner"></div>
//         <p>Loading your profile...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="profile-container">
//         <div className="error-message">
//           <h2>Error loading profile</h2>
//           <p>{error}</p>
//           <button 
//             className="action-button"
//             onClick={() => navigate('/login')}
//           >
//             Go to Login
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!userData) {
//     return (
//       <div className="profile-container">
//         <div className="error-message">
//           <h2>Profile not found</h2>
//           <p>Please log in to view your profile</p>
//           <button 
//             className="action-button"
//             onClick={() => navigate('/login')}
//           >
//             Go to Login
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="profile-container">
//       <h1>My Profile</h1>

//       <div className="profile-details">
//         <div className="profile-header">
//           <h2>Welcome, {userData.name}</h2>
//           <button 
//             className="refresh-btn"
//             onClick={handleRefreshProfile}
//             title="Refresh profile data"
//           >
//             ↻
//           </button>
//         </div>

//         <div className="profile-info">
//           <div className="info-item">
//             <div className="info-label">Email:</div>
//             <div className="info-value">{userData.email}</div>
//           </div>

//           {userData.phone && (
//             <div className="info-item">
//               <div className="info-label">Phone:</div>
//               <div className="info-value">{userData.phone}</div>
//             </div>
//           )}

//           {userData.deliveryAddress && (
//             <div className="info-item">
//               <div className="info-label">Delivery Address:</div>
//               <div className="info-value">{userData.deliveryAddress}</div>
//             </div>
//           )}

//           {/* Enhanced loyalty points display */}
//           <div className="info-item loyalty-points">
//             <div className="info-label">Loyalty Points:</div>
//             <div className="info-value points-value">
//               {userData.points !== undefined ? (
//                 <>
//                   <span className="points-number">{userData.points}</span> points
//                 </>
//               ) : '0 points'}
//             </div>
//           </div>
//         </div>

//         {/* Recent Points Activity Section */}
//         {recentPointsActivity.length > 0 && (
//           <div className="points-activity-section">
//             <h3>Recent Points Activity</h3>
//             <div className="points-activity-list">
//               {recentPointsActivity.map(activity => (
//                 <div key={activity.id} className="points-activity-item">
//                   <div className="activity-date">
//                     {new Date(activity.date).toLocaleDateString()}
//                   </div>
//                   <div className="activity-description">
//                     {activity.description}
//                   </div>
//                   <div className="activity-points">
//                     +{activity.points} points
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="profile-actions">
//           <button 
//             className="edit-profile-btn"
//             onClick={() => navigate('/profile/edit')}
//           >
//             Edit Profile
//           </button>

//           <button 
//             className="view-orders-btn"
//             onClick={() => navigate('/orders')}
//           >
//             View Orders
//           </button>

//           <button 
//             className="logout-btn"
//             onClick={handleLogout}
//           >
//             Log Out
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;




// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { doc, getDoc, collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
// import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
// import { db } from '../../firebase/firebaseConfig';
// import './ProfilePage.css';

// const ProfilePage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [recentOrders, setRecentOrders] = useState([]);
//   const [recentPointsActivity, setRecentPointsActivity] = useState([]);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
//   const auth = getAuth();

//   // Function to fetch user data from Firestore
//   const fetchUserData = useCallback(async (user) => {
//     try {
//       setLoading(true);

//       if (!user || !user.uid) {
//         throw new Error('User not authenticated');
//       }

//       console.log("Fetching user data for:", user.uid);

//       // Set initial user data from auth
//       const initialUserData = {
//         uid: user.uid,
//         email: user.email || '',
//         name: user.displayName || 'User',
//         points: 0 // Initialize points to 0 if not found
//       };

//       // Fetch complete user data from Firestore
//       try {
//         const userDocRef = doc(db, 'users', user.uid);
//         const userDocSnap = await getDoc(userDocRef);

//         if (userDocSnap.exists()) {
//           console.log("Found user document directly with ID:", user.uid);
//           const firestoreData = userDocSnap.data();

//           // Merge with existing data, ensuring points is included
//           const mergedData = {
//             ...initialUserData,
//             ...firestoreData,
//             points: firestoreData.points || 0, // Ensure points is always defined
//             lastUpdated: new Date().toISOString()
//           };

//           setUserData(mergedData);

//           // Save to localStorage as a cache
//           localStorage.setItem('userData', JSON.stringify(mergedData));
//         } else {
//           // Try to find user by email as fallback
//           console.log("User document not found by ID, trying email query");
//           const usersRef = collection(db, 'users');
//           const q = query(usersRef, where('email', '==', user.email));
//           const querySnapshot = await getDocs(q);

//           if (!querySnapshot.empty) {
//             const firestoreData = querySnapshot.docs[0].data();
//             const firestoreUserId = querySnapshot.docs[0].id;

//             console.log("Found user by email query with ID:", firestoreUserId);

//             // Merge with existing data
//             const mergedData = {
//               ...initialUserData,
//               ...firestoreData,
//               uid: firestoreUserId,
//               points: firestoreData.points || 0, // Ensure points is always defined
//               lastUpdated: new Date().toISOString()
//             };

//             setUserData(mergedData);

//             // Save to localStorage as a cache
//             localStorage.setItem('userData', JSON.stringify(mergedData));
//           } else {
//             console.log("No user document found in Firestore. Using basic auth data.");
//             setUserData(initialUserData);
//             localStorage.setItem('userData', JSON.stringify(initialUserData));
//           }
//         }
//       } catch (firestoreError) {
//         console.error("Error fetching user data from Firestore:", firestoreError);
//         // Continue with auth data
//         setUserData(initialUserData);
//       }

//     } catch (error) {
//       console.error("Error in profile page:", error);
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   // Fetch recent orders
//   const fetchRecentOrders = useCallback(async (userId) => {
//     try {
//       if (!userId) return;

//       const ordersRef = collection(db, 'orders');
//       const q = query(
//         ordersRef,
//         where('userId', '==', userId),
//         orderBy('createdAt', 'desc'),
//         limit(5)
//       );

//       const querySnapshot = await getDocs(q);
//       const ordersData = [];

//       querySnapshot.forEach((doc) => {
//         ordersData.push({
//           id: doc.id,
//           ...doc.data(),
//           createdAt: doc.data().createdAt ? doc.data().createdAt.toDate() : new Date()
//         });
//       });

//       setRecentOrders(ordersData);

//       // Extract points activity from orders
//       const pointsActivity = ordersData.map(order => ({
//         id: order.id,
//         date: order.createdAt,
//         description: `Order #${order.orderId}`,
//         points: order.pointsEarned || 0,
//         type: 'earned'
//       }));

//       setRecentPointsActivity(pointsActivity);

//     } catch (error) {
//       console.error("Error fetching recent orders:", error);
//     }
//   }, []);

//   // Main useEffect to check authentication and load user data
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         fetchUserData(user);
//         fetchRecentOrders(user.uid);
//       } else {
//         // User is not logged in
//         setLoading(false);
//         navigate('/login');
//       }
//     });

//     // Cleanup subscription
//     return () => unsubscribe();
//   }, [navigate, auth, fetchUserData, fetchRecentOrders, refreshTrigger]);

//   // Listen for profile refresh events
//   useEffect(() => {
//     // Force refresh when returning from order page
//     const checkForRefresh = () => {
//       const params = new URLSearchParams(location.search);
//       if (params.get('refresh') === 'true') {
//         console.log("Detected refresh parameter, triggering data reload");
//         setRefreshTrigger(prev => prev + 1);

//         // Clean up the URL
//         navigate('/profile', { replace: true });
//       }
//     };

//     checkForRefresh();

//     // Listen for custom refresh events
//     const handleRefreshEvent = () => {
//       console.log("Received profile refresh event");
//       setRefreshTrigger(prev => prev + 1);
//     };

//     window.addEventListener('refreshProfile', handleRefreshEvent);

//     return () => {
//       window.removeEventListener('refreshProfile', handleRefreshEvent);
//     };
//   }, [location, navigate]);

//   // Manually refresh profile data
//   const handleRefreshProfile = () => {
//     console.log("Manual refresh triggered");
//     setLoading(true);
//     setRefreshTrigger(prev => prev + 1);
//   };

//   const handleLogout = async () => {
//     try {
//       setLoading(true);

//       // Use Firebase signOut instead of manually clearing localStorage
//       await signOut(auth);

//       // Clear user data from localStorage
//       localStorage.removeItem('userData');
//       localStorage.removeItem('authToken');

//       // Use in-memory variable instead of sessionStorage
//       window.hasSeenWelcome = false;

//       // Dispatch logout event if needed
//       window.dispatchEvent(new Event('userLoggedOut'));

//       navigate('/login');
//     } catch (error) {
//       console.error("Error during logout:", error);
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="profile-container">
//         <div className="loading-spinner"></div>
//         <p>Loading your profile...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="profile-container">
//         <div className="error-message">
//           <h2>Error loading profile</h2>
//           <p>{error}</p>
//           <button
//             className="action-button"
//             onClick={() => navigate('/login')}
//           >
//             Go to Login
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!userData) {
//     return (
//       <div className="profile-container">
//         <div className="error-message">
//           <h2>Profile not found</h2>
//           <p>Please log in to view your profile</p>
//           <button
//             className="action-button"
//             onClick={() => navigate('/login')}
//           >
//             Go to Login
//           </button>
//         </div>
//       </div>
//     );
//   }




//   return (
//     <div className="profile-container">
      

//       <h1>My Profile</h1>

//       <div className="profile-details">
//         <div className="profile-header">
//           <h2>Welcome, {userData.name}</h2>
//           <button
//             className="refresh-btn"
//             onClick={handleRefreshProfile}
//             title="Refresh profile data"
//           >
//             ↻
//           </button>
//         </div>

//         <div className="profile-info">
//           <div className="info-item">
//             <div className="info-label">Email:</div>
//             <div className="info-value">{userData.email}</div>
//           </div>

//           {userData.phone && (
//             <div className="info-item">
//               <div className="info-label">Phone:</div>
//               <div className="info-value">{userData.phone}</div>
//             </div>
//           )}

//           {userData.deliveryAddress && (
//             <div className="info-item">
//               <div className="info-label">Delivery Address:</div>
//               <div className="info-value">{userData.deliveryAddress}</div>
//             </div>
//           )}

//           {/* Enhanced loyalty points display */}
//           <div className="info-item loyalty-points">
//             <div className="info-label">Loyalty Points:</div>
//             <div className="info-value points-value">
//               <span className="points-number">{userData.points || 0}</span> points
//             </div>
//           </div>
//         </div>

//         {/* Recent Points Activity Section */}
//         {recentPointsActivity.length > 0 && (
//           <div className="points-activity-section">
//             <h3>Recent Points Activity</h3>
//             <div className="points-activity-list">
//               {recentPointsActivity.map(activity => (
//                 <div key={activity.id} className="points-activity-item">
//                   <div className="activity-date">
//                     {new Date(activity.date).toLocaleDateString()}
//                   </div>
//                   <div className="activity-description">
//                     {activity.description}
//                   </div>
//                   <div className="activity-points">
//                     +{activity.points} points
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="profile-actions">
//           <button
//             className="edit-profile-btn"
//             onClick={() => navigate('/profile/edit')}
//           >
//             Edit Profile
//           </button>

//           <button
//             className="view-orders-btn"
//             onClick={() => navigate('/orders')}
//           >
//             View Orders
//           </button>

//           <button
//             className="logout-btn"
//             onClick={handleLogout}
//           >
//             Log Out
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;







import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc, collection, query, where, getDocs, orderBy, limit, Timestamp } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { db } from '../../firebase/firebaseConfig';
import './ProfilePage.css';

const ProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [recentOrders, setRecentOrders] = useState([]);
  const [recentPointsActivity, setRecentPointsActivity] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const auth = getAuth();

  // Function to fetch user data from Firestore
  const fetchUserData = useCallback(async (user) => {
    try {
      setLoading(true);

      if (!user || !user.uid) {
        throw new Error('User not authenticated');
      }

      console.log("Fetching user data for:", user.uid);

      // Set initial user data from auth
      const initialUserData = {
        uid: user.uid,
        email: user.email || '',
        name: user.displayName || 'User',
        points: 0 // Initialize points to 0 if not found
      };

      // Fetch complete user data from Firestore
      try {
        const userDocRef = doc(db, 'users', user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          console.log("Found user document directly with ID:", user.uid);
          const firestoreData = userDocSnap.data();

          // Merge with existing data, ensuring points is included
          const mergedData = {
            ...initialUserData,
            ...firestoreData,
            points: firestoreData.points || 0, // Ensure points is always defined
            lastUpdated: new Date().toISOString()
          };

          setUserData(mergedData);

          // Save to localStorage as a cache
          localStorage.setItem('userData', JSON.stringify(mergedData));
        } else {
          // Try to find user by email as fallback
          console.log("User document not found by ID, trying email query");
          const usersRef = collection(db, 'users');
          const q = query(usersRef, where('email', '==', user.email));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const firestoreData = querySnapshot.docs[0].data();
            const firestoreUserId = querySnapshot.docs[0].id;

            console.log("Found user by email query with ID:", firestoreUserId);

            // Merge with existing data
            const mergedData = {
              ...initialUserData,
              ...firestoreData,
              uid: firestoreUserId,
              points: firestoreData.points || 0, // Ensure points is always defined
              lastUpdated: new Date().toISOString()
            };

            setUserData(mergedData);

            // Save to localStorage as a cache
            localStorage.setItem('userData', JSON.stringify(mergedData));
          } else {
            console.log("No user document found in Firestore. Using basic auth data.");
            setUserData(initialUserData);
            localStorage.setItem('userData', JSON.stringify(initialUserData));
          }
        }
      } catch (firestoreError) {
        console.error("Error fetching user data from Firestore:", firestoreError);
        // Continue with auth data
        setUserData(initialUserData);
      }

    } catch (error) {
      console.error("Error in profile page:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1, { replace: true });
  };

  // Fetch recent orders and points activity
  const fetchRecentOrders = useCallback(async (userId) => {
    try {
      if (!userId) return;

      const ordersRef = collection(db, 'orders');
      const q = query(
        ordersRef,
        where('userId', '==', userId),
        orderBy('createdAt', 'desc'),
        limit(5)
      );

      const querySnapshot = await getDocs(q);
      const ordersData = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        ordersData.push({
          id: doc.id,
          ...data,
          createdAt: data.createdAt ? (data.createdAt.toDate ? data.createdAt.toDate() : new Date(data.createdAt)) : new Date()
        });
      });

      setRecentOrders(ordersData);

      // Extract points activity from orders
      const pointsActivity = [];
      
      // Add points earned from orders
      ordersData.forEach(order => {
        if (order.pointsEarned && order.pointsEarned > 0) {
          pointsActivity.push({
            id: `${order.id}-earned`,
            date: order.createdAt,
            description: `Order #${order.id.substring(0, 6)}`,
            points: order.pointsEarned,
            type: 'earned',
            orderId: order.id
          });
        }
        
        if (order.pointsUsed && order.pointsUsed > 0) {
          pointsActivity.push({
            id: `${order.id}-used`,
            date: order.createdAt,
            description: `Points redeemed for Order #${order.id.substring(0, 6)}`,
            points: order.pointsUsed,
            type: 'used',
            orderId: order.id
          });
        }
      });

      // Sort by date, most recent first
      pointsActivity.sort((a, b) => b.date - a.date);
      
      setRecentPointsActivity(pointsActivity);

    } catch (error) {
      console.error("Error fetching recent orders:", error);
    }
  }, []);

  // Main useEffect to check authentication and load user data
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        fetchUserData(user);
        fetchRecentOrders(user.uid);
      } else {
        // User is not logged in
        setLoading(false);
        navigate('/login');
      }
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, [navigate, auth, fetchUserData, fetchRecentOrders, refreshTrigger]);

  // Listen for profile refresh events
  useEffect(() => {
    // Force refresh when returning from order page
    const checkForRefresh = () => {
      const params = new URLSearchParams(location.search);
      if (params.get('refresh') === 'true') {
        console.log("Detected refresh parameter, triggering data reload");
        setRefreshTrigger(prev => prev + 1);

        // Clean up the URL
        navigate('/profile', { replace: true });
      }
    };

    checkForRefresh();

    // Listen for custom refresh events
    const handleRefreshEvent = () => {
      console.log("Received profile refresh event");
      setRefreshTrigger(prev => prev + 1);
    };

    window.addEventListener('refreshProfile', handleRefreshEvent);

    return () => {
      window.removeEventListener('refreshProfile', handleRefreshEvent);
    };
  }, [location, navigate]);

  // Manually refresh profile data
  const handleRefreshProfile = () => {
    console.log("Manual refresh triggered");
    setLoading(true);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleLogout = async () => {
    try {
      setLoading(true);

      // Use Firebase signOut instead of manually clearing localStorage
      await signOut(auth);

      // Clear user data from localStorage
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');

      // Use in-memory variable instead of sessionStorage
      window.hasSeenWelcome = false;

      // Dispatch logout event if needed
      window.dispatchEvent(new Event('userLoggedOut'));

      navigate('/login');
    } catch (error) {
      console.error("Error during logout:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="pfp-container">
        <div className="pfp-loading-spinner"></div>
        <p>Loading your profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pfp-container">
        <div className="pfp-error">
          <h2>Error loading profile</h2>
          <p>{error}</p>
          <button
            className="pfp-action-button"
            onClick={() => navigate('/login')}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="pfp-container">
        <div className="pfp-error">
          <h2>Profile not found</h2>
          <p>Please log in to view your profile</p>
          <button
            className="pfp-action-button"
            onClick={() => navigate('/login')}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="pfp-page-container">
      <div className="pfp-content">
        {/* Profile Banner with Avatar and Stats */}
        <div className="pfp-banner">
          <div className="pfp-header">
            <img
              src={userData.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userData.name)}&background=D32F2F&color=fff&size=130&bold=true`}
              alt="Profile Avatar"
              className="pfp-avatar"
            />
            <div className="pfp-info">
              <h1 className="pfp-name">{userData.name || 'User'}</h1>
              <p className="pfp-email">{userData.email}</p>
              <div className="pfp-stats">
                <div className="pfp-stat-item">
                  <span className="pfp-stat-value">{recentOrders.length}</span>
                  <span className="pfp-stat-label">Total Orders</span>
                </div>
                <div className="pfp-stat-item">
                  <span className="pfp-stat-value">{userData.points || 0}</span>
                  <span className="pfp-stat-label">Loyalty Points</span>
                </div>
              </div>
            </div>
            <button className="pfp-edit-button" onClick={() => navigate('/profile/edit')}>
              Edit Profile
            </button>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="pfp-sections">
          {/* Sidebar - User Info Card */}
          <div className="pfp-sidebar">
            <div className="pfp-card">
              <h2>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Account Details
              </h2>
              <div className="pfp-info-row">
                <span className="pfp-info-label">Email</span>
                <span className="pfp-info-value">{userData.email}</span>
              </div>
              {userData.phone && (
                <div className="pfp-info-row">
                  <span className="pfp-info-label">Phone</span>
                  <span className="pfp-info-value">{userData.phone}</span>
                </div>
              )}
              {userData.deliveryAddress && (
                <div className="pfp-info-row">
                  <span className="pfp-info-label">Address</span>
                  <span className="pfp-info-value">{userData.deliveryAddress}</span>
                </div>
              )}
              <div className="pfp-info-row">
                <span className="pfp-info-label">Loyalty Points</span>
                <span className="pfp-info-value" style={{color: '#D32F2F', fontWeight: '700', fontSize: '1.1rem'}}>
                  {userData.points || 0} pts
                </span>
              </div>
            </div>
          </div>

          {/* Main Content - Orders and Activity */}
          <div className="pfp-main">
            {/* Tab Navigation */}
            <div className="pfp-tabs">
              <button className="pfp-tab-button active">Recent Orders</button>
              <button className="pfp-tab-button" onClick={() => navigate('/orders')}>All Orders</button>
            </div>

            {/* Recent Orders List */}
            <div className="pfp-card">
              <h2>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                Recent Orders
              </h2>
              {recentOrders.length > 0 ? (
                <div className="pfp-orders">
                  {recentOrders.map((order) => (
                    <div key={order.id} className="pfp-order-item" onClick={() => navigate(`/orders?highlight=${order.id}`)}>
                      <div className="pfp-order-details">
                        <h3>Order #{order.id.substring(0, 8)}</h3>
                        <p className="pfp-order-date">
                          {order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          }) : 'N/A'}
                        </p>
                      </div>
                      <span className={`pfp-order-status ${order.status || 'pending'}`}>
                        {order.status || 'Pending'}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{textAlign: 'center', color: '#64748B', padding: '40px 20px'}}>
                  No orders yet. Start shopping to see your orders here!
                </p>
              )}
            </div>

            {/* Points Activity */}
            {recentPointsActivity.length > 0 && (
              <div className="pfp-card">
                <h2>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                  Recent Points Activity
                </h2>
                <div className="pfp-orders">
                  {recentPointsActivity.map((activity) => (
                    <div 
                      key={activity.id} 
                      className="pfp-order-item"
                      onClick={() => activity.orderId && navigate(`/orders?highlight=${activity.orderId}`)}
                      style={{cursor: activity.orderId ? 'pointer' : 'default'}}
                    >
                      <div className="pfp-order-details">
                        <h3>{activity.description}</h3>
                        <p className="pfp-order-date">
                          {new Date(activity.date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </p>
                      </div>
                      <span className={`pfp-order-status ${activity.type === 'used' ? 'pending' : 'delivered'}`}>
                        {activity.type === 'used' ? '-' : '+'}{activity.points} pts
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="pfp-card">
              <h2>Quick Actions</h2>
              <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '15px'}}>
                <button
                  onClick={() => navigate('/orders')}
                  style={{
                    flex: '1',
                    minWidth: '200px',
                    padding: '14px 24px',
                    background: 'linear-gradient(135deg, #1E3A5F 0%, #2D4A6F 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(30, 58, 95, 0.3)'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  View All Orders
                </button>
                <button
                  onClick={handleLogout}
                  style={{
                    flex: '1',
                    minWidth: '200px',
                    padding: '14px 24px',
                    background: 'linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;